import * as React from "react";
import {observer} from "mobx-react-lite";
import {
    CBody1,
    CButton,
    CCard,
    CCardContent,
    CContainer,
    CGridContainer, CH1
} from "../../components";
import {useNavigate} from "react-router-dom";

export const Onboarding = observer(
    function Onboarding() {
        const navigate = useNavigate();

        return (
            <>
                <main style={{minHeight: '100vh'}}>
                    <CContainer
                        style={{display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center'}}>
                        <CCard>
                            <CCardContent sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}>

                                <CH1 sx={{
                                    mb: 2,
                                    fontWeight: '900',
                                    color: '#424242'
                                }}>
                                    Welcome
                                </CH1>
                                <CBody1 sx={{
                                    mb: 4,
                                    color: '#424242'
                                }}>
                                    This is ABX Business frontend.
                                </CBody1>
                                <CGridContainer>
                                    <CButton sx={{mr:2}} size="medium" variant="contained" onClick={()=>navigate('/login')}>
                                        Login
                                    </CButton>
                                    <CButton size="medium" variant="contained" onClick={()=>navigate('/panel')}>
                                        Panel
                                    </CButton>
                                </CGridContainer>

                            </CCardContent>
                        </CCard>
                    </CContainer>
                </main>
            </>
        );
    }
)
